













































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import { throttle, download } from '@/utils/util'
import RevisitApi from '@/api/revisit'
import PartnerApi from '@/api/partner'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'partnerFirstAuditDetail',
	components: {
		PageLayout,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = {}
	private injured: any = {}
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private returnForm: any = {}
	private mediaOrder: any = []
	private mediaMap: any = {}
	private mediaInfoMap: any = {}
	private ws: any = ''
	private activeKey: any = '1'
	private timer: any = ''
	private expireTimer: any = ''
	private throttleOpenWS = throttle(10 * 1000)
	private once: boolean = false
	private exporting: boolean = false
	private visitorPhone: any = ''
	private cancelLoading: boolean = false
	private revokeDialogVisible: boolean = false
	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private evaluateForm: any = {}
	private evaluateVisible: boolean = false
	private evaluateLoading: boolean = false
	private rate: number = 5
	private labelMap: any = {}
	private labelList: any = []
	private evaluateInfo: any = {}
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private show: any = ''
	private visitorPopupShow: boolean = false
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	private lastOrderInfo: any = ''
	private addForm: any = {}
	private addLoading: boolean = false
	private saving: boolean = false
	private detail: any = ''

	private back() {
		this.$router.go(-1)
	}

	private start() {
		this.$confirm({
			title: '提示',
			content(h: any) {
				return h('div', {}, [
					h('div', '确认是否提前开始审核任务 ?'),
					h(
						'div',
						{
							style: {
								color: '#969696',
								marginTop: '6px',
							},
						},
						'注：开启任务即时生效，任务开启时间变换成当前时间。'
					),
				])
			},
			onOk: () => {
				return PartnerApi.beginCheck(this.$route.params.id).then((res: any) => {
					this.$message.success(res.message)
					this.getDetail()
				})
			},
		})
	}

	private cancel() {
		this.$confirm({
			title: '提示',
			content(h: any) {
				return h('div', {}, [
					h('div', '确认是否取消审核任务 ?'),
					h(
						'div',
						{
							style: {
								color: '#969696',
								marginTop: '6px',
							},
						},
						'注：取消任务即时生效，任务结束时间变换成当前时间。'
					),
				])
			},
			onOk: () => {
				return PartnerApi.cancelCheck(this.$route.params.id).then(
					(res: any) => {
						this.$message.success(res.message)
						this.getDetail()
					}
				)
			},
		})
	}

	private update() {
		this.$ss.set('auditInfoId', this.$route.params.id)
		this.$router.push(`/partner/updateAuditInfo`)
	}

	private getDetail() {
		return PartnerApi.getCheckDetail(this.$route.params.id).then(
			(data: any) => {
				this.detail = data.data
			}
		)
	}

	private created() {
		this.addForm = this.$form.createForm(this)
	}

	private deactivated() {}

	private activated() {
		this.order = ''
		this.getDetail()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.order = ''
			this.getDetail()
		})
		next()
	}
}
